// When updating releases update the On-Premises linkTo attribute to the same as lastRelease.
// Due to object not being able to self-ref.

module.exports = {
  cloudRelease: 'cloud',
  lastRelease: '5.0',
  mainDocsUrl: 'https://docs.incorta.com',
  lastSuportedReleases: [
    '5.1',
    '5.0',
    '4.9',
    '4.8',
    '4.7',
    '4.6',
    '4.5',
    '4.4',
    '4.3',
  ],
  algoliaReleases: ['5.0', '4.9', '4.8', '4.7', '4.6', '4.5', '4.4', '4.3'],
  // nav links
  nav: [
    {
      text: 'Home',
      linkTo: 'https://docs.incorta.com',
      context: '',
      hasLocale: true,
    },
    {
      text: 'Cloud',
      linkTo: 'https://docs.incorta.com/cloud',
      context: ['cloud'],
      hasLocale: true,
      externalLink: true,
    },
    {
      text: 'On-Premises',
      //Change with lastRelease change
      context: ['5.0', '4.9', '4.8', '4.7', '4.6', '4.5', '4.4', '4.3'],
      linkTo: '5.0',
      hasLocale: true,
    },
  ],
}
